import { API_ENDPOINT } from '@Env/variables';
import { createAxiosInstance } from './axios';

interface UploadUrlResponse {
  uploadUrl: string;
  key: string;
  bucket: string;
}

export const fileAPI = (logout: () => void) => {
  const axios = createAxiosInstance(logout, API_ENDPOINT);

  return {
    getUploadUrl: async (
      fileType: string,
      fileName: string,
      source?: string
    ): Promise<UploadUrlResponse> => {
      const { data } = await axios.post<UploadUrlResponse>(
        '/api/getUploadUrl',
        {
          fileType,
          fileName,
          source,
        }
      );
      return data;
    },

    uploadFile: async (
      uploadUrl: string,
      file: File,
      mimeType: string
    ): Promise<void> => {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': mimeType,
        },
      });

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }
    },
  };
};
